import { Component, HostListener } from '@angular/core'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss'],
  standalone: false,
})
export class ScrollToTopComponent {
  faArrowUp = faArrowUp
  isVisible = false

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.isVisible = window.scrollY > 300
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
